export function getPromo(discounts, promoId = null, code = null) {
  if (!discounts || !Array.isArray(discounts)) {
    return null;
  }
  return discounts.find(
    (discount) =>
      discount.promoId === promoId ||
      discount.code === code ||
      discount.promoCode === code
  );
}
